import React, { useState } from "react";
import { Paper, Stack, Typography, Box, Skeleton } from "@mui/material";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";

import RecallFilters from "./RecallFilters";
import RecallStats from "./RecallStats";
import RecallTable from "./RecallTable";
import InfoButton from "./InfoButton";
import { HELP_CONTENT } from "../../constants/clinicalHelpContent";

/**
 * Panel 5: Recall
 * Mini-stats de distribución + tabla de pacientes sin visita reciente.
 */
export default function PanelRecall({ recall, loading, onCreateTask }) {
  const [filters, setFilters] = useState({
    search: "",
    healthStatus: "All",
    since: "All",
  });

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Stack spacing={2}>
        {/* Header */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 28,
              height: 28,
              borderRadius: 1.5,
              bgcolor: "#FEE2E2",
              color: "#DC2626",
            }}
          >
            <EventRepeatIcon sx={{ fontSize: 16 }} />
          </Box>
          <Typography variant="subtitle2" fontWeight={700}>
            Patient Recall
          </Typography>
          <InfoButton helpContent={HELP_CONTENT.recall} />
        </Stack>

        {/* Stats */}
        <RecallStats
          distribution={recall?.distribution}
          contactability={recall?.contactability}
          loading={loading}
        />

        {/* Filters */}
        {loading ? (
          <Stack direction="row" spacing={1.5}>
            <Skeleton variant="rounded" width={200} height={36} />
            <Skeleton variant="rounded" width={130} height={36} />
            <Skeleton variant="rounded" width={130} height={36} />
          </Stack>
        ) : (
          <RecallFilters filters={filters} onFilterChange={setFilters} />
        )}

        {/* Table */}
        <RecallTable
          recallList={recall?.recallList}
          filters={filters}
          loading={loading}
          onCreateTask={onCreateTask}
        />
      </Stack>
    </Paper>
  );
}
